import React from "react";

export const PromoTitles = ({ promoTiles }) => {
    console.log(promoTiles);
    return (
        <div className="promo_titles">
            {promoTiles.map(
                ({ id, nombre_boton, foto, hash_foto, url, formato }) => {
                    return (
                        <div
                            style={{
                                background: `url(/storage/promos/${id}/${hash_foto})`
                            }}
                            className="promo"
                            key={id}
                        >
                            <a
                                target={`${
                                    formato === "externo" ? "_blank" : "_self"
                                }`}
                                rel="noopener noreferrer"
                                href={url}
                            >
                                {nombre_boton}
                                <img
                                    className="ml-half"
                                    src="/images/icons/small.svg"
                                />
                            </a>
                        </div>
                    );
                }
            )}
        </div>
    );
};
